import { defineMessages } from 'react-intl';

export const templatesMessages = defineMessages({
  documentTemplates: {
    id: 'templates.documentTemplates',
    defaultMessage: 'Document Templates',
  },
  encounterSchemas: {
    id: 'templates.encounterSchemas',
    defaultMessage: 'Encounter Schemas',
  },
  statusDraft: {
    id: 'templates.status.draft',
    defaultMessage: 'Draft',
  },
  statusCurrent: {
    id: 'templates.status.current',
    defaultMessage: 'Current',
  },
  statusObsolete: {
    id: 'templates.status.obsolete',
    defaultMessage: 'Obsolete',
  },
  statusDeleted: {
    id: 'templates.status.deleted',
    defaultMessage: 'Deleted',
  },
  typeSummary: {
    id: 'templates.type.summary',
    defaultMessage: 'Summary',
  },
  typeEvaluation: {
    id: 'templates.type.evaluation',
    defaultMessage: 'Evaluation',
  },
  typeFollowUpLetter: {
    id: 'templates.type.followUpLetter',
    defaultMessage: 'Follow-up Letter',
  },
  typeLiteratureReview: {
    id: 'templates.type.literatureReview',
    defaultMessage: 'Literature Review',
  },
  typeTemplate: {
    id: 'templates.type.template',
    defaultMessage: 'Template',
  },
});

// Keyed by the catalog's specialty value, so lookups use the raw backend string.
export const templateSpecialtyMessages = defineMessages({
  'General Practice': {
    id: 'templates.specialty.generalPractice',
    defaultMessage: 'General Practice',
  },
  'Family Medicine': {
    id: 'templates.specialty.familyMedicine',
    defaultMessage: 'Family Medicine',
  },
  Psychiatry: {
    id: 'templates.specialty.psychiatry',
    defaultMessage: 'Psychiatry',
  },
  Psychology: {
    id: 'templates.specialty.psychology',
    defaultMessage: 'Psychology',
  },
  Dentistry: {
    id: 'templates.specialty.dentistry',
    defaultMessage: 'Dentistry',
  },
  Physiotherapy: {
    id: 'templates.specialty.physiotherapy',
    defaultMessage: 'Physiotherapy',
  },
  Veterinary: {
    id: 'templates.specialty.veterinary',
    defaultMessage: 'Veterinary',
  },
  Cardiology: {
    id: 'templates.specialty.cardiology',
    defaultMessage: 'Cardiology',
  },
  Dermatology: {
    id: 'templates.specialty.dermatology',
    defaultMessage: 'Dermatology',
  },
  Neurology: {
    id: 'templates.specialty.neurology',
    defaultMessage: 'Neurology',
  },
  Orthopedics: {
    id: 'templates.specialty.orthopedics',
    defaultMessage: 'Orthopedics',
  },
  Pediatrics: {
    id: 'templates.specialty.pediatrics',
    defaultMessage: 'Pediatrics',
  },
  Surgery: {
    id: 'templates.specialty.surgery',
    defaultMessage: 'Surgery',
  },
  Other: {
    id: 'global.other',
    defaultMessage: 'Other',
  },
});
